import React from "react";
import { connect } from "react-redux";
import BreadCrumComponent from "../../componentes/BreadCrumComponent";
import PantallaCarga from "../../mensajeFlash/PantallaCarga";
import MensajeFlash from "../../mensajeFlash/MensajeFlash";

import {
  obtenerCabeceraLegajo,
  obtenerDatosPersonales,
  getTelefonos,
  getCorreos,
  getRedes,
  getDocumentos,
  getAcademicos,
  getCapacitaciones,
  getExperiencias,
  getCargos,
  getEvaluaciones,
  descargarLegajoFile,
} from "./LegajoService";

class VerLegajo extends React.Component {
  constructor(props) {
    super(props);

    const legajoId =
      props?.location?.state?.legajo?.legajoId ||
      props?.location?.state?.legajo?.id ||
      props?.match?.params?.legajoId ||
      props?.match?.params?.id ||
      "";

    this.state = {
      legajoId,
      tab: "DATOS_PERSONALES",
      cabecera: null,
      datosPersonales: null,
      telefonos: [],
      correos: [],
      redes: [],
      documentos: [],
      academicos: [],
      capacitaciones: [],
      experiencias: [],
      cargos: [],
      evaluaciones: [],
      cargando: true,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "neutral",
    };
  }

  componentDidMount() {
    this.cargarTodo();
  }

  cargarTodo = async () => {
    const { legajoId } = this.state;
    if (!legajoId) {
      this.setState({ cargando: false, mostrarMensajeFlash: true, mensajeFlash: "No se recibió el ID del legajo.", mensajeFlashSeverity: "error" });
      return;
    }

    try {
      this.setState({ cargando: true });

      const [cab, dp, tels, cors, reds, docs, acads, caps, exps, cars, evals] =
        await Promise.all([
          this.props.obtenerCabeceraLegajo(legajoId),
          this.props.obtenerDatosPersonales(legajoId),
          this.props.getTelefonos(legajoId),
          this.props.getCorreos(legajoId),
          this.props.getRedes(legajoId),
          this.props.getDocumentos(legajoId),
          this.props.getAcademicos(legajoId),
          this.props.getCapacitaciones(legajoId),
          this.props.getExperiencias(legajoId),
          this.props.getCargos(legajoId),
          this.props.getEvaluaciones(legajoId),
        ]);

      this.setState({
        cargando: false,
        cabecera: cab?.datos || null,
        datosPersonales: dp?.datos || null,
        telefonos: tels?.datos || tels || [],
        correos: cors?.datos || cors || [],
        redes: reds?.datos || reds || [],
        documentos: docs?.datos || docs || [],
        academicos: acads?.datos || acads || [],
        capacitaciones: caps?.datos || caps || [],
        experiencias: exps?.datos || exps || [],
        cargos: cars?.datos || cars || [],
        evaluaciones: evals?.datos || evals || [],
      });
    } catch (e) {
      this.setState({ cargando: false, mostrarMensajeFlash: true, mensajeFlash: "No se pudo cargar el legajo.", mensajeFlashSeverity: "error" });
    }
  };

  setTab = (tab) => this.setState({ tab });

  formatDate = (value) => {
    if (!value) return "--";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "--";
    return d.toLocaleDateString("es-PY");
  };

  descargarArchivo = async (fileId, fallbackName = "archivo") => {
    try {
      const res = await this.props.descargarLegajoFile(fileId);
      const blob = new Blob([res.data], { type: res.headers["content-type"] || "application/octet-stream" });
      const cd = res.headers["content-disposition"] || "";
      const match = cd.match(/filename="(.+?)"/);
      const filename = match?.[1] || fallbackName;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      this.setState({ mostrarMensajeFlash: true, mensajeFlash: "No se pudo descargar el archivo.", mensajeFlashSeverity: "error" });
    }
  };

  handleEditar = () => {
    const { legajoId, cabecera } = this.state;
    this.props.history.push({
      pathname: `/administracion/legajo/editar/${legajoId}`,
      state: { legajo: { legajoId, ...cabecera } },
    });
  };

  // =========================
  // Render Cabecera
  // =========================
  renderCabecera = () => {
    const c = this.state.cabecera;
    if (!c) return null;

    return (
      <div className="card mb-2">
        <div className="card-header-actions">
          <h3 className="card-title">Datos del colaborador</h3>
          <button className="btn-medium btn-primary-tonal" onClick={this.handleEditar}>
            <span className="material-symbols-outlined">edit</span>
            Editar legajo
          </button>
        </div>

        <div className="cabecera-grid">
          <div className="cabecera-col">
            <div className="card-info">
              <span className="label">Legajo ID</span>
              <span className="txt">{c.legajoId}</span>
            </div>
            <div className="card-info">
              <span className="label">Nombre y apellido</span>
              <span className="txt">{c.nombre} {c.apellido}</span>
            </div>
            <div className="card-info">
              <span className="label">Username</span>
              <span className="txt">{c.username || "--"}</span>
            </div>
            <div className="card-info">
              <span className="label">Miembro / Empresa</span>
              <span className="txt">Miembro #{c.miembroId} — Empresa #{c.empresaId}</span>
            </div>
          </div>

          <div className="cabecera-col">
            <div className="card-info">
              <span className="label">Cédula</span>
              <span className="txt">{c.cedula || "--"}</span>
            </div>
            <div className="card-info">
              <span className="label">Correo</span>
              <span className="txt">{c.correo || "--"}</span>
            </div>
            <div className="card-info">
              <span className="label">Teléfono principal</span>
              <span className="txt">{c.telefonoPrincipal || "--"}</span>
            </div>
            <div className="card-info">
              <span className="label">Estado</span>
              <span className={`txt badge-estado ${c.estado === "ACTIVO" ? "badge-activo" : "badge-baja"}`}>
                {c.estado || "--"}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // =========================
  // Render Tabs
  // =========================
  renderTabs = () => {
    const tabs = [
      ["DATOS_PERSONALES", "Datos personales", "person"],
      ["TELEFONOS", "Teléfonos", "call"],
      ["CORREOS", "Correos", "mail"],
      ["REDES", "Redes", "share"],
      ["DOCUMENTOS", "Documentos", "description"],
      ["ACADEMICOS", "Académicos", "school"],
      ["CAPACITACIONES", "Capacitaciones", "workspace_premium"],
      ["EXPERIENCIAS", "Experiencias", "work"],
      ["CARGOS", "Cargos", "work_history"],
      ["EVALUACIONES", "Evaluaciones", "insights"],
    ];

    return (
      <div className="tabs-cards">
        {tabs.map(([key, label, icon]) => (
          <button
            key={key}
            type="button"
            className={`tab-card ${this.state.tab === key ? "active" : ""}`}
            onClick={() => this.setTab(key)}
          >
            <div className="tab-card__content">
              <span className="material-symbols-outlined tab-card__icon">{icon}</span>
              <span className="tab-card__title">{label}</span>
            </div>
          </button>
        ))}
      </div>
    );
  };

  // =========================
  // Render Datos Personales
  // =========================
  renderDatosPersonales = () => {
    const dp = this.state.datosPersonales;
    if (!dp) return <p className="empty-section">Sin datos personales registrados.</p>;

    const campos = [
      { label: "Fecha de nacimiento", valor: this.formatDate(dp.fechaNacimiento) },
      { label: "Sexo", valor: dp.sexo },
      { label: "Estado civil", valor: dp.estadoCivil },
      { label: "Nacionalidad", valor: dp.nacionalidad },
      { label: "Dirección", valor: dp.direccion },
      { label: "Ciudad", valor: dp.ciudadDireccion },
      { label: "País", valor: dp.paisDireccion },
      { label: "Código interno", valor: dp.codigoInterno },
    ];

    return (
      <div className="card">
        <h3 className="form-subtitle">Datos personales</h3>
        <div className="info-grid">
          {campos.map(({ label, valor }) => (
            <div className="card-info" key={label}>
              <span className="label">{label}</span>
              <span className="txt">{valor || "--"}</span>
            </div>
          ))}
          <div className="card-info">
            <span className="label">Confidencial</span>
            <span className="txt">{dp.esConfidencial ? "Sí" : "No"}</span>
          </div>
        </div>
      </div>
    );
  };

  // =========================
  // Render tabla genérica (solo lectura)
  // =========================
  renderTablaSeccion = ({ title, sectionKey, columns, conArchivo = false, getFileId }) => {
    const rows = this.state[sectionKey] || [];

    return (
      <div className="card">
        <h3 className="form-subtitle">{title}</h3>

        {rows.length === 0 ? (
          <p className="empty-section">No hay registros en esta sección.</p>
        ) : (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  {columns.map((c) => <th key={c.key}>{c.label}</th>)}
                  {conArchivo && <th>Archivo</th>}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => (
                  <tr key={row.id ?? `${sectionKey}-${idx}`}>
                    {columns.map((c) => (
                      <td key={c.key}>
                        {c.type === "date"
                          ? this.formatDate(row[c.key])
                          : c.type === "checkbox"
                          ? (row[c.key] ? "Sí" : "No")
                          : row[c.key] ?? "--"}
                      </td>
                    ))}
                    {conArchivo && (
                      <td>
                        {getFileId && getFileId(row) ? (
                          <button
                            className="table-icon"
                            title="Descargar archivo"
                            onClick={() => this.descargarArchivo(getFileId(row))}
                          >
                            <span className="material-symbols-outlined">download</span>
                          </button>
                        ) : (
                          <span className="txt">--</span>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // =========================
  // Render contenido según tab
  // =========================
  renderContenidoTab = () => {
    const { tab } = this.state;

    switch (tab) {
      case "DATOS_PERSONALES":
        return this.renderDatosPersonales();

      case "TELEFONOS":
        return this.renderTablaSeccion({
          title: "Teléfonos",
          sectionKey: "telefonos",
          columns: [
            { key: "numero", label: "Número" },
            { key: "tipo", label: "Tipo" },
          ],
        });

      case "CORREOS":
        return this.renderTablaSeccion({
          title: "Correos",
          sectionKey: "correos",
          columns: [
            { key: "correo", label: "Correo" },
            { key: "tipo", label: "Tipo" },
          ],
        });

      case "REDES":
        return this.renderTablaSeccion({
          title: "Redes sociales",
          sectionKey: "redes",
          columns: [
            { key: "red", label: "Red" },
            { key: "url", label: "URL / Usuario" },
          ],
        });

      case "DOCUMENTOS":
        return this.renderTablaSeccion({
          title: "Documentos personales",
          sectionKey: "documentos",
          columns: [
            { key: "tipo", label: "Tipo" },
            { key: "numero", label: "Número" },
            { key: "fechaEmision", label: "Emisión", type: "date" },
            { key: "fechaVencimiento", label: "Vencimiento", type: "date" },
          ],
          conArchivo: true,
          getFileId: (row) => row.archivoId,
        });

      case "ACADEMICOS":
        return this.renderTablaSeccion({
          title: "Registros académicos",
          sectionKey: "academicos",
          columns: [
            { key: "institucion", label: "Institución" },
            { key: "titulo", label: "Título" },
            { key: "tipoFormacion", label: "Tipo" },
            { key: "fechaInicio", label: "Inicio", type: "date" },
            { key: "fechaFin", label: "Fin", type: "date" },
            { key: "completado", label: "Completado", type: "checkbox" },
          ],
          conArchivo: true,
          getFileId: (row) => row.certificadoArchivoId,
        });

      case "CAPACITACIONES":
        return this.renderTablaSeccion({
          title: "Capacitaciones",
          sectionKey: "capacitaciones",
          columns: [
            { key: "nombre", label: "Nombre" },
            { key: "institucion", label: "Institución" },
            { key: "fechaInicio", label: "Inicio", type: "date" },
            { key: "fechaFin", label: "Fin", type: "date" },
            { key: "horas", label: "Horas" },
            { key: "completado", label: "Completado", type: "checkbox" },
          ],
          conArchivo: true,
          getFileId: (row) => row.certificadoArchivoId,
        });

      case "EXPERIENCIAS":
        return this.renderTablaSeccion({
          title: "Experiencia laboral",
          sectionKey: "experiencias",
          columns: [
            { key: "empresa", label: "Empresa" },
            { key: "cargo", label: "Cargo" },
            { key: "fechaInicio", label: "Inicio", type: "date" },
            { key: "fechaFin", label: "Fin", type: "date" },
            { key: "descripcion", label: "Descripción" },
          ],
        });

      case "CARGOS":
        return this.renderTablaSeccion({
          title: "Cargos",
          sectionKey: "cargos",
          columns: [
            { key: "cargo", label: "Cargo" },
            { key: "departamento", label: "Departamento" },
            { key: "fechaInicio", label: "Inicio", type: "date" },
            { key: "fechaFin", label: "Fin", type: "date" },
            { key: "actual", label: "Actual", type: "checkbox" },
          ],
        });

      case "EVALUACIONES":
        return this.renderTablaSeccion({
          title: "Evaluaciones",
          sectionKey: "evaluaciones",
          columns: [
            { key: "tipo", label: "Tipo" },
            { key: "puntaje", label: "Puntaje" },
            { key: "fecha", label: "Fecha", type: "date" },
            { key: "observaciones", label: "Observaciones" },
          ],
        });

      default:
        return null;
    }
  };

  // =========================
  // Render principal
  // =========================
  render() {
    const { cargando, mostrarMensajeFlash, mensajeFlash, mensajeFlashSeverity } = this.state;

    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={"/administracion/legajos"}
                breadcrumbs={[
                  { label: "Legajos", path: "/administracion/legajos" },
                  { label: "Ver legajo" },
                ]}
              />

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">Detalle del legajo</h1>
                  <p className="page-description">
                    Visualización completa del legajo del colaborador
                  </p>
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container">
              {cargando ? (
                <PantallaCarga mensaje="Cargando legajo..." />
              ) : (
                <>
                  {this.renderCabecera()}
                  {this.renderTabs()}
                  {this.renderContenidoTab()}
                </>
              )}
            </div>
          </div>
        </div>

        <MensajeFlash
          visible={mostrarMensajeFlash}
          mensaje={mensajeFlash}
          severity={mensajeFlashSeverity}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  obtenerCabeceraLegajo: (id) => dispatch(obtenerCabeceraLegajo(id)),
  obtenerDatosPersonales: (id) => dispatch(obtenerDatosPersonales(id)),
  getTelefonos: (id) => dispatch(getTelefonos(id)),
  getCorreos: (id) => dispatch(getCorreos(id)),
  getRedes: (id) => dispatch(getRedes(id)),
  getDocumentos: (id) => dispatch(getDocumentos(id)),
  getAcademicos: (id) => dispatch(getAcademicos(id)),
  getCapacitaciones: (id) => dispatch(getCapacitaciones(id)),
  getExperiencias: (id) => dispatch(getExperiencias(id)),
  getCargos: (id) => dispatch(getCargos(id)),
  getEvaluaciones: (id) => dispatch(getEvaluaciones(id)),
  descargarLegajoFile: (fileId) => dispatch(descargarLegajoFile(fileId)),
});

export default connect(null, mapDispatchToProps)(VerLegajo);
